import axios from "axios";



// axios.defaults.baseURL = "https://dev-api.betaplay.ng/api/v1/";

// axios.defaults.baseURL = "https://dev-api.betaplay.ng/api/v1/";
// axios.defaults.baseURL = "http://localhost:8080/api/v1/";
axios.defaults.baseURL = 'https://api.betaplay.ng/api/v1/';

axios.defaults.headers.post["Content-Type"] = "application/json";

// content type
const token: any = localStorage.getItem("accessToken");
if (token) axios.defaults.headers.common["Authorization"] = "Bearer " + token;

// intercepting to capture errors
axios.interceptors.response.use(
  function (response) {
    return response.data ? response.data : response;
  },
  function (error: any) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    const status = error?.response?.status;
    const detail = error?.response?.data?.detail;
    let message: string;
    switch (status) {
      case 500:
        message = "Internal Server Error";
        break;
      case 401:
        message = "Invalid credentials";
        localStorage.removeItem("accessToken");
        window.location.href = "/login";
        break;
      case 404:
        message = "Sorry! the data you are looking for could not be found";
        break;
      default:
        message =
          (typeof detail === "string" && detail) ||
          error?.response?.data?.message ||
          error?.message ||
          "Request failed";
    }
    return Promise.reject(message);
  }
);
/**
 * Sets the default authorization
 * @param {*} token
 */
const setAuthorization = (token: any) => {
  axios.defaults.headers.common["Authorization"] = "Bearer " + token;
};

class APIClient {
  get = (url: any, params: any) => {
    let response;

    let paramKeys: any = [];

    if (params) {
      Object.keys(params).map((key) => {
        paramKeys.push(key + "=" + params[key]);
        return paramKeys;
      });

      const queryString =
        paramKeys && paramKeys.length ? paramKeys.join("&") : "";
      response = axios.get(`${url}?${queryString}`, params);
    } else {
      response = axios.get(`${url}`, params);
    }

    return response;
  };
  /**
   * post given data to url
   */
  create = (url: any, data: any) => {
    return axios.post(url, data);
  };
  /**
   * Updates data
   */
  update = (url: any, data: any) => {
    return axios.patch(url, data);
  };

  put = (url: any, data: any) => {
    return axios.put(url, data);
  };
  /**
   * Delete
   */
  delete = (url: any, config: any) => {
    return axios.delete(url, { ...config });
  };
}
const getLoggedUser = () => {
  const user = localStorage.getItem("user");
  if (!user) {
    return null;
  } else {
    return JSON.parse(user);
  }
};

async function getUser(user: User | null | undefined): Promise<User | null> {
  if (!user) return null;
  const response = await fetch(`/api/users/${user.user.id}`, {
    headers: {
      Authorization: `Bearer ${user.accessToken}`,
    },
  });
  if (!response.ok) throw new Error("Failed on get user request");

  return await response.json();
}

export interface User {
  accessToken: string;
  user: {
    email: string;
    id: number;
  };
}

export { APIClient, setAuthorization, getLoggedUser, getUser };
